module.exports = __webpack_public_path__ + "static/media/github.19c45735.png";